import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles/custom.scss';
import './my-bootstrap-italia.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Use the createRoot API for React 18
const container = document.getElementById('root');
const root = createRoot(container); // Create a root.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
